// Rótulo de Acessibilidade - accessibilityLabel
type accessibilityLabel = { pass: { accessibilityLabel: any } };
export const accessibilityLabel = (props: accessibilityLabel) => {
  const { accessibilityLabel } = props.pass;

  console.log({ accessibilityLabel });

  // return; aqui fica comentado por enquanto
};

// Alternativo - alt
type alt = { pass: { alt: any } };
export const alt = (props: alt) => {
  const { alt } = props.pass;

  console.log({ alt });

  // return; aqui fica comentado por enquanto
};

// Raio de Desfoque - blurRadius
type blurRadius = { pass: { blurRadius: any } };
export const blurRadius = (props: blurRadius) => {
  const { blurRadius } = props.pass;

  console.log({ blurRadius });

  // return; aqui fica comentado por enquanto
};

// Inserções - capInsets
type capInsets = { pass: { capInsets: any } };
export const capInsets = (props: capInsets) => {
  const { capInsets } = props.pass;

  console.log({ capInsets });

  // return; aqui fica comentado por enquanto
};

// Origem Cruzada - crossOrigin
type Tprops_crossOrigin = { pass: { crossOrigin: any } };
export const crossOrigin = (props: Tprops_crossOrigin) => {
  const { crossOrigin } = props.pass;

  console.log({ crossOrigin });

  // return; aqui fica comentado por enquanto
};

// Fonte Padrão - defaultSource
type Tprops_defaultSource = { pass: { defaultSource: any } };
export const defaultSource = (props: Tprops_defaultSource) => {
  const { defaultSource } = props.pass;

  console.log({ defaultSource });

  // return; aqui fica comentado por enquanto
};

// Duração do Esmaecimento - fadeDuration
type Tprops_fadeDuration = { pass: { fadeDuration: any } };
export const fadeDuration = (props: Tprops_fadeDuration) => {
  const { fadeDuration } = props.pass;

  console.log({ fadeDuration });

  // return; aqui fica comentado por enquanto
};

// Altura - height
type Tprops_height = { pass: { height: any } };
export const height = (props: Tprops_height) => {
  const { height } = props.pass;

  console.log({ height });

  // return; aqui fica comentado por enquanto
};

// Fonte do Indicador de Carregamento - loadingIndicatorSource
type Tprops_loadingIndicatorSource = { pass: { loadingIndicatorSource: any } };
export const loadingIndicatorSource = (
  props: Tprops_loadingIndicatorSource,
) => {
  const { loadingIndicatorSource } = props.pass;

  console.log({ loadingIndicatorSource });

  // return; aqui fica comentado por enquanto
};

// Ajuste de Objeto - objectFit
type Tprops_objectFit = { pass: { objectFit: any } };
export const objectFit = (props: Tprops_objectFit) => {
  const { objectFit } = props.pass;

  console.log({ objectFit });

  // return; aqui fica comentado por enquanto
};

// Ao dar Erro - onError
type Tprops_onError = { pass: { onError: any } };
export const onError = (props: Tprops_onError) => {
  const { onError } = props.pass;

  console.log({ onError });

  // return; aqui fica comentado por enquanto
};

// Ao Alterar Layout - onLayout
type Tprops_onLayout = { pass: { onLayout: any } };
export const onLayout = (props: Tprops_onLayout) => {
  const { onLayout } = props.pass;

  console.log({ onLayout });

  // return; aqui fica comentado por enquanto
};

// Ao Carregar com Sucesso - onLoad
type Tprops_onLoad = { pass: { onLoad: any } };
export const onLoad = (props: Tprops_onLoad) => {
  const { onLoad } = props.pass;

  console.log({ onLoad });

  // return; aqui fica comentado por enquanto
};

// Ao Carregar - onLoadEnd
type Tprops_onLoadEnd = { pass: { onLoadEnd: any } };
export const onLoadEnd = (props: Tprops_onLoadEnd) => {
  const { onLoadEnd } = props.pass;

  console.log({ onLoadEnd });

  // return; aqui fica comentado por enquanto
};

// Ao Iniciar Carregamento - onLoadStart
type Tprops_onLoadStart = { pass: { onLoadStart: any } };
export const onLoadStart = (props: Tprops_onLoadStart) => {
  const { onLoadStart } = props.pass;

  console.log({ onLoadStart });

  // return; aqui fica comentado por enquanto
};

// --------------------------------------
// --------------------------------------
// --------------------------------------
